import React, { useEffect } from 'react';
import { bool, oneOf, shape, string } from 'prop-types';

import ActionIcon, { FEEDBACK_TYPES } from 'components/ActionIcon';
import styles from './styles';

const FEEDBACK_TIMEOUT = 3000;

function CopyLinkAction({
  disabledMessage,
  gtmAttrs,
  isBranded,
  isDisabled,
  placement,
  url,
  variant
}) {
  const input = React.useRef(null);
  const [tooltipMessage, setTooltipMessage] = React.useState(undefined);

  // Reset state when url changes
  useEffect(() => {
    setTooltipMessage(undefined);
  }, [url]);

  useEffect(() => {
    let timeout;
    if (tooltipMessage) {
      timeout = window.setTimeout(() => {
        setTooltipMessage(undefined);
      }, FEEDBACK_TIMEOUT);
    }
    return () => {
      if (timeout) {
        window.clearTimeout(timeout);
      }
    };
  }, [tooltipMessage]);

  function handleClickCopy(e) {
    e.preventDefault();
    if (!isDisabled && 'execCommand' in document) {
      // Select the input...
      input.current.select();
      // and copy the selection
      document.execCommand('copy');
      setTooltipMessage('Copied to clipboard!');
    } else {
      setTooltipMessage(disabledMessage);
    }
  }

  return (
    <div className="CopyLinkAction">
      <style jsx>{styles}</style>
      <ActionIcon
        feedbackType={FEEDBACK_TYPES.tooltip}
        isBranded={isBranded}
        isDisabled={isDisabled}
        label={tooltipMessage || undefined}
        linkAttrs={{
          'data-gtm-placement': placement,
          'data-gtm-url': url,
          ...gtmAttrs
        }}
        onClick={handleClickCopy}
        type="link"
        url={url}
        variant={variant}
      />
      {url && (
        <input
          data-test="urlInput"
          readOnly
          ref={input}
          type="text"
          value={url}
        />
      )}
    </div>
  );
}

CopyLinkAction.propTypes = {
  disabledMessage: string,
  gtmAttrs: shape({}),
  isBranded: bool,
  isDisabled: bool,
  placement: string.isRequired,
  url: string.isRequired,
  variant: oneOf(['default', 'fitted'])
};

CopyLinkAction.defaultProps = {
  disabledMessage: undefined,
  gtmAttrs: {},
  isBranded: false,
  isDisabled: false,
  variant: 'default'
};

export default CopyLinkAction;
